import { render, staticRenderFns } from "./DesmatamentoArgentina.vue?vue&type=template&id=2f7fa8e8&lang=pug"
import script from "./DesmatamentoArgentina.vue?vue&type=script&lang=js"
export * from "./DesmatamentoArgentina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports